import Svg, { Path } from 'react-native-svg'

export const QrIcon = ({ height = 16, width = 16, color = '#fff' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M4.667 10H3.333C2.6 10 2 10.6 2 11.333v1.334C2 13.4 2.6 14 3.333 14h1.334C5.4 14 6 13.4 6 12.667v-1.334C6 10.6 5.4 10 4.667 10ZM8 6c.367 0 .667-.3.667-.667V2.667C8.667 2.3 8.367 2 8 2c-.367 0-.667.3-.667.667v2.666c0 .367.3.667.667.667Zm4.667-4h-1.334C10.6 2 10 2.6 10 3.333v1.334C10 5.4 10.6 6 11.333 6h1.334C13.4 6 14 5.4 14 4.667V3.333C14 2.6 13.4 2 12.667 2ZM3.333 6h1.334C5.4 6 6 5.4 6 4.667V3.333C6 2.6 5.4 2 4.667 2H3.333C2.6 2 2 2.6 2 3.333v1.334C2 5.4 2.6 6 3.333 6Zm9.334 1.333h-1.334c-.733 0-1.333.6-1.333 1.334V10c0 .733.6 1.333 1.333 1.333h1.334c.733 0 1.333-.6 1.333-1.333V8.667c0-.734-.6-1.334-1.333-1.334Zm.666 5.334H8.667v-4c0-.734-.6-1.334-1.334-1.334H2.667C2.3 7.333 2 7.633 2 8c0 .367.3.667.667.667h4.666v4c0 .733.6 1.333 1.334 1.333h4.666c.367 0 .667-.3.667-.667 0-.366-.3-.666-.667-.666Z"
      />
    </Svg>
  )
}
